import {FileDTO} from '../model/ServiceRequest'
import {BlobUploadCommonResponse, BlockBlobClient} from '@azure/storage-blob'
import {saveAs} from 'file-saver'

export const uploadServiceRequestFileToBlobStorage = async (fileDTO: FileDTO | null, file: File) => {
    // if no file, don't try to upload it
    if (!fileDTO?.uri) return
    return uploadServiceRequestFilesToBlobStorage([fileDTO], [file])
}

export const uploadServiceRequestFilesToBlobStorage = async (filesDTO: FileDTO[], files: File[]) => {
    const filesByName = files.reduce((acc, file) => {
        acc.set(file.name, file)
        return acc
    }, new Map<string, File>())

    const fileUploadRequests = filesDTO.map(async (fileDTO: FileDTO) => {
        if (!fileDTO?.uri) return
        const file = filesByName.get(fileDTO.name)
        if (!file) return

        // upload file on storage account
        const blockBlobClient = new BlockBlobClient(fileDTO.uri)
        const arrayBufferFile = await file.arrayBuffer()
        return await blockBlobClient.uploadData(arrayBufferFile)
    }).filter((x): x is Promise<BlobUploadCommonResponse> => x !== undefined)

    await Promise.all(fileUploadRequests)
}

export const saveFileFromBlobStorage = async (fileDTO: FileDTO) => {
    if (!fileDTO.uri) throw new Error('File not found')

    // Fetch the bytes, then save as a blob to avoid new tab behavior
    const res = await fetch(fileDTO.uri)
    if (!res.ok) throw new Error(`Download failed: ${res.status}`)
    const blob = await res.blob()
    saveAs(blob, fileDTO.name)
}
